import React, { PureComponent } from 'react';
import { Trans } from '@lingui/macro';

class SystemRouteOD extends PureComponent {
    constructor(props) {
        super(props);
        this.genContent = this.genContent.bind(this);
        const top10 = [];
        const { data, geo } = props;

        const keysSorted = Object.keys(props.data)
            .sort((a, b) => props.data[a] - props.data[b])
            .reverse();

        const top10Keys = keysSorted.slice(0, 10);
        top10Keys.forEach((key) => {
            if (data[key]) {
                const [origin, destination] = key.split(':');
                top10.push({
                    origin: geo[origin].station,
                    dest: geo[destination].station,
                    num: data[key],
                });
            }
        });

        this.state = {
            top10,
        };
    }

    genDesktopContent = () => {
        const { top10 } = this.state;
        return (
            <table className="table top-10-table">
                <thead>
                    <tr>
                        <th style={{ width: '43%' }}>
                            <Trans id="od.origin" />
                        </th>
                        <th style={{ width: '43%' }}>
                            <Trans id="od.destination" />
                        </th>
                        <th className="d-none d-md-block">
                            <Trans id="system.dealNumber" />
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {top10.map((item) => (
                        <tr key={`${item.origin}${item.dest}`}>
                            <td>{item.origin}</td>
                            <td>{item.dest}</td>
                            <td className="d-none d-md-block">{item.num}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    }

    genMobileContent = () => {
        const { top10 } = this.state;

        return (
            <table className="table top-10-table">
                <thead>
                    <tr>
                        <th style={{ width: '43%' }}>
                            <Trans id="origin" />
                            {' '}
                          →
                            <Trans id="destination" />
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {top10.map((item) => (
                        <tr key={item.num}>
                            <td>
                                <div>{item.origin}</div>
                                <div>↓</div>
                                <div>{item.dest}</div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    }

    genContent() {
        const { isMobile } = this.props;
        if (isMobile) return this.genMobileContent();
        return this.genDesktopContent();
    }

    render() {
        return (
            <div className="mb-3">
                <h3 className="system-head">
                    <Trans id="system.routeTitle" />
                </h3>
                <div className="row">
                    <div className="col-md-12 col-xs-12">
                        <div className="table-responsive">{this.genContent()}</div>
                    </div>
                </div>
            </div>
        );
    }
}

export default SystemRouteOD;
